export const trimStartEndOfString = (str) => {
  return str.trimStart().trimEnd().replace('\r\n', '\n')
}
